export enum PlatformAudit {
  JuvOffice = "JuvOffice",
}